import { ReactNode } from "react";

export interface PaymentMethodModuleData {
	paymentmethod?: string;
	currency?: string;
	status?: React.ReactNode | string;
	date?: string;
	createdat?: string;
	// action?: string;
	action?: ReactNode;
	iseditable?: ReactNode;
	id?: number;
	merchantaccountid?: number;
}

export const ColumnPaymentMethodModule = [
	{
		Header: "Payment method",
		accessor: "paymentmethod",
	},
	{
		Header: "Currency",
		accessor: "currency",
	},
	{
		Header: "Created At",
		accessor: "createdat",
	},
	{
		Header: "Status",
		accessor: "status",
	},
	{
		Header: "Action",
		accessor: "iseditable",
	},
];
